<template>
  <div v-html="translation('pagina.cookie')">

  </div>
</template>

<script>
import translationStore from '@/store/translations'

export default {
  name: 'PrivacyView', // Nome componente più specifico
  data () {
    return {
      translationStore: translationStore
    }
  },

  computed: {
    translation () {
      return translationStore.getters.traduzione
    }
  }

}
</script>

<style scoped>
/*
 * Ho usato <style scoped> per isolare questi stili al componente.
 * Se hai bisogno di stili globali (come per la griglia row/col), usa <style> non scoped.
 * Gli stili qui sotto sono locali e specifici per i contenuti della privacy.
 */

/* Formattazione Titoli */
::v-deep h1 {
  font-size: 2.5em;
  color: #1a1a1a;
  margin-top: 0;
  margin-bottom: 20px;
  border-bottom: 2px solid #ddd;
  padding-bottom: 10px;
}

::v-deep h2 {
  font-size: 1.8em;
  color: #444;
  margin-top: 30px;
  margin-bottom: 15px;
}

::v-deep h3 {
  font-size: 1.2em;
  color: #444;
  margin-top: 20px;
  margin-bottom: 5px;
}

</style>
